import { getBaseUrl } from "@/lib/utils/url";

export const routes = {
  root: "/",
  admin: "/admin",
  connectors: "/connectors",
  gotIntros: "/got-intros",
  home: "/",
  intros: "/intros",
  invitation: "/invitation",
  library: "/library",
  networkSignals: "/network-signals",
  people: "/people",
  referrals: "/referrals",
  signin: "/signin",
  signout: "/signout",
  networkLeads: "/network-leads",
  account: {
    general: "/account/general",
    security: "/account/security",
    billing: "/account/billing",
    integrations: "/account/integrations",
  },
  default: "/network-signals",
};

export const referralRoutes = {
  referrals: (workspaceSlug: string) => `/${workspaceSlug}/referrals`,
  referralsSettings: (workspaceSlug: string) => `/${workspaceSlug}/referrals/settings`,
  referralsPublic: (workspaceSlug: string) => {
    const baseUrl = getBaseUrl();
    const url = new URL(baseUrl);
    url.hostname = `referrals.${url.hostname.replace(/^(dashboard|app|internal)\./, "")}`;
    return `${url.origin}/${workspaceSlug}`;
  },
} as const;
